<template>
  <div>
    <b-modal ref="auditTrailModal" :title="modalTitle" ok-only>
      <template v-if="modalItemList != null && !isDetailEmpty">
        <div v-for="(value, key) in modalItemList">
          {{ key }}: {{value}}
        </div>
      </template>
      <div v-else>
        <span>N/A</span>
      </div>
    </b-modal>
    <FITFormCard>
      <div slot="header">
        <h4>{{$t('adm.auditTrail.title')}}</h4>
      </div>
      <div slot="formBody">
        <FITSearchableTable @onRowSelected="onRowSelected" vuexModule="Adm" searchAction="getAuditTrailList" :filters="filters" :columns="columns" :autoSearchFilters="autoSearchFilters" :small="true"></FITSearchableTable>
      </div>
    </FITFormCard>
  </div>
</template>
<script>
import {
  FITModal,
  FITSearchableTable,
  FITFormCard
} from '@/components'

import Vue from 'vue'
export default {
  name: 'AuditTrailList',
  components: {
    FITSearchableTable,
    FITFormCard,
    FITModal
  },
  computed: {
    modalTitle() {
      return this.$t('adm.auditTrail.title') + ' - ' + this.$t('adm.auditTrail.actionDetail');
    },
    isDetailEmpty() {
      for (var key in this.modalItemList) {
        if (this.modalItemList.hasOwnProperty(key))
          return false;
      }
      return true;
    }
  },
  methods: {
    onRowSelected(val) {
      Vue.set(this, 'modalItemList', val.actionDetail);
      this.$refs.auditTrailModal.show();
    },
    getFunctionList() {
      this.$store.dispatch('Adm/getAuditTrailFunctionList')
        .then((json) => {
          Vue.set(this, 'auditTrailFunctionList', json.data.list);
        }).catch((err) => {
          console.log(err);
        })
    }
  },
  created() {
    this.getFunctionList();
  },
  data() {
    return {
      modalItemList: {},
      auditTrailFunctionList: [],
      columns: [{
        key: 'userName',
        label: this.$t('adm.auditTrail.user'),
        formatter: (row, key, item) => {
          return '<div>' + item.userEnglishName + '</div>' + '<div>' + item.userChineseName + '</div>'
        }
      }, {
        key: 'actionDate',
        sortable: true,
        label: this.$t('adm.auditTrail.actionDate'),
      }, {
        key: 'function',
        label: this.$t('adm.auditTrail.function'),
        sortable: true,
      }, ],
      actions: [
        { text: this.$t('osm.contents.general.detail'), key: 'detail' },
        { text: this.$t('osm.contents.general.outstandingRequirement.title'), key: 'outstanding' }
      ],
      autoSearchFilters: [{
        label: this.$t('adm.auditTrail.function'),
        key: 'function',
        searchParams: {
          placeholder: 'Type to search',
          options: []
        }
      }],
      filters: [{
          label: this.$t('general.fromDate'),
          key: 'fromDate',
          type: 'datetime',
          default: ''
        },
        {
          label: this.$t('general.toDate'),
          key: 'toDate',
          type: 'datetime',
          default: ''
        }
      ],
      form: {

      },
    }
  },
  watch: {
    auditTrailFunctionList(newData, oldData) {
      Vue.set(this.autoSearchFilters[0].searchParams, 'options', newData);
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/Adm/AuditTrail/AuditTrailList.vue